import "@/App.css";
import { LangProvider } from "@/context/LangContext";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";

function App() {
  return (
    <LangProvider>
      <HomePage />
      <Toaster position="bottom-right" theme="dark" />
    </LangProvider>
  );
}

export default App;
